module.exports = __webpack_public_path__ + "static/fonts/ac-icons.c5a3aed2.woff2";